import { Empty } from "antd";
import React from "react";
import empt from "../../assets/svg/empt.svg";
import { useMediaQuery } from "react-responsive";

const EmptyData = (props) => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	return (
		<div tw="h-full! w-full! p-2! md:p-6! flex items-center justify-center">
			<Empty
				image={empt}
				imageStyle={{
					height: isMobile ? 120 : 200,
				}}
				description={props.description ? props.description : null}>
				{props.children ? props.children : null}
			</Empty>
		</div>
	);
};

export default EmptyData;
